import { Component } from '@angular/core';
import {  OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { Project } from '../shared/project';
import { ProjectService } from '../shared/project.service';

import { ConfirmationService } from 'primeng/primeng';


@Component({
    selector: 'project-list',
    templateUrl: './project-list.component.html',
    styleUrls: ['./project-list.component.scss']
})
export class ProjectListComponent implements OnInit, OnDestroy {

    @Input() selectedProject;
    @Output() selectedProjectChange = new EventEmitter();
    @Input() operation: string;
    fromRoute: boolean;

    projects: Project[];


    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;

    constructor(public rootService: RootService,
        public translate: TranslateService) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/app/module/project/project-list/project-list.component.ts